import {Fragment, useContext} from "react";
import {useParams} from 'react-router-dom';
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ApiUtility} from "../common/ApiUtility";
import {AuthUtility} from "../common/AuthUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {Constants} from "../common/Constants";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {UserForm} from "./UserForm";

type UpdateUserPageRouteParams = {
    userId: string;
}

export let UpdateUserPage = function () {
    if (!AuthUtility.userHasEnforcedPermissions([Constants.permissionNames.userUpdate])) return null;
    const context = useContext(GlobalContext);
    const params = useParams<UpdateUserPageRouteParams>()
    const modelUpdateEngine = useModelUpdateEngine(
        ApiUtility.getUser,
        ApiUtility.updateUser,
        '' + params.userId,
        'user',
        () => context.navigator.goBack(),
        {}
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().model} renderer={() => (
                <UserForm
                    cancel={() => context.navigator.goBack()}
                    save={modelUpdateEngine.updateModel}
                    user={modelUpdateEngine.dataStore.data().model}
                    isNew={false}
                />
            )}/>
        </Fragment>
    );
};
